/**
 * Documentation Page
 *
 * Full-page component for the /docs route.
 */

import { DocsBrowser } from './DocsBrowser';

export function DocsPage() {
  return (
    <div className="h-full">
      <DocsBrowser />
    </div>
  );
}
